<!-- 入库明细编辑弹框 -->
<template>
  <van-overlay :show="show">
    <div class="form-content" v-if="info" @click.stop>
      <div class="tool">
        <label>商品维护</label>
        <i class="iconfont guanbi" @click="onSendClose"></i>
      </div>
      <div class="form">
        <section>
          <label>商品名称</label>
          <label>{{ info.productName }}</label>
        </section>
        <section>
          <label>国际编码</label>
          <label>{{ info.barCode }}</label>
        </section>
        <section>
          <label>规格</label>
          <label>{{ info.specVal }}</label>
        </section>
        <section>
          <label>数量</label>
          <label>
            <van-field v-model="info.qty" value="info.qty" @input="handleChangeQty" type="number"/>
          </label>
        </section>
        <section>
          <label>箱数</label>
          <label>
            <van-field v-model="info.boxQty" value="info.qty" type="number"/>
          </label>
        </section>
        <section>
          <label>效期</label>
          <label class="date" @click="onDateStart">
            <span v-if="info.productDate">{{ info.productDate | dateSub }}</span>
            <span v-else>{{ periodDaysStartDate }}</span>
          </label>
        </section>
        <section>
          <label>~</label>
          <label class="date" @click="onDateEnd">
            <span v-if="info.invalidDate">{{ info.invalidDate | dateSub }}</span>
            <span v-else>{{ periodDaysEndDate }}</span>
          </label>
        </section>
        <section>
          <label>批次</label>
          <label>
            <van-field v-model="info.batSn" value="info.itemSn"/>
          </label>
        </section>
<!--        <section>-->
<!--          <label>项次</label>-->
<!--          <label>-->
<!--            <van-field v-model="info.itemSn" value="info.itemSn"/>-->
<!--          </label>-->
<!--        </section>-->
        <section class="rejects-flag">
          <div v-for="status in ProductStatus()" :key="status.value" @click="defectFlagChange(status.value)">
            <i class="iconfont xuanze1" :class="status.value === productStatus ? 'xuanze1' : 'xuanze2'"></i>
            <span>{{status.label}}</span>
          </div>
        </section>
      </div>
      <div class="sub-tool">
        <label v-if="!saveSubDisable" @click="onSaveDetailInfo">保存</label>
        <label v-else style="background-color:#f0f0f0;color:#444;">保存</label>
      </div>
    </div>
    <div class="date-picker" @click.stop v-if="showDatePicker">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="onDateSure"
        @cancel="showDatePicker=false"
      />
    </div>
  </van-overlay>
</template>

<script>
import DataFormat from "../util/dataFormat.js";
import Utils from "../util/utils";
import {ProductStatus} from "../common/constant";

export default {
  data() {
    return {
      currentDate: new Date(),
      showDatePicker: false,
      dateChangeType: 0, // 效期改变方式 0--效期计算时增加  1--效期计算时减少
      periodDaysStartDate: DataFormat.formatDate(new Date(), "YYYY-MM-DD"), // 效期开始时间
      periodDaysEndDate: DataFormat.formatDate(new Date(), "YYYY-MM-DD"), // 效期结束时间
      saveSubDisable: false, // 提交按钮禁用
      productStatus: 1
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: {
      }
    },
    // 明细保存方式（0--新增，1--更新）
    saveDetailInfoType: {
      type: Number,
      default: 0
    }
  },
  watch: {
    // 弹窗打开/切换明细，同步赋值内部副本
    info: {
      handler(val) {
        this.productStatus = val.productStatus
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ProductStatus() {
      return ProductStatus
    },
    handleChangeQty(v) {
      this.info.boxQty = Utils.calcBoxNum(v, this.info.packSpecVal)
    },
    // 发送关闭事件
    onSendClose() {
      this.$emit("closeDialog");
    },
    // 时间确定
    onDateSure(value) {
      let advanceDay = this.info.advanceDay || 30
      this.showDatePicker = false;
      if (this.dateChangeType === 1) {
        this.periodDaysEndDate = DataFormat.formatDate(value, "YYYY-MM-DD");
        this.periodDaysStartDate = DataFormat.dateChange(1, this.periodDaysEndDate, advanceDay);
        this.info.productDate = this.periodDaysStartDate;
        this.info.invalidDate = this.periodDaysEndDate;
      } else {
        this.periodDaysStartDate = DataFormat.formatDate(value, "YYYY-MM-DD");
        this.periodDaysEndDate = DataFormat.dateChange(0, this.periodDaysStartDate, advanceDay);
        this.info.productDate = this.periodDaysStartDate;
        this.info.invalidDate = this.periodDaysEndDate;
      }

    },
    // 效期开始时间变化事件
    onDateStart(value) {
      this.showDatePicker = true;
      this.dateChangeType = 0;
    },
    // 效期结束时间变化事件
    onDateEnd() {
      this.showDatePicker = true;
      this.dateChangeType = 1;
    },
    // 良品/不良品切换
    defectFlagChange(val) {
      this.productStatus = val;
      this.info.productStatus = val
    },
    // 明细保存处理
    onSaveDetailInfo() {
      let param = {
        id: this.info.id,
        inboundApplyId: this.info.inboundApplyId,
        inboundDetailId: this.info.inboundDetailId,
        productId: this.info.productId,
        productCode: this.info.productCode,
        productName: this.info.productName,
        barCode: this.info.barCode,
        qty: this.info.qty,
        boxQty: this.info.boxQty,
        specVal: this.info.specVal,
        batSn: this.info.batSn,
        itemSn: this.info.itemSn,
        productDate: DataFormat.formatDate(this.periodDaysStartDate, 'YYYY-MM-DD HH:mm:ss'),
        invalidDate: DataFormat.formatDate(this.periodDaysEndDate,'YYYY-MM-DD HH:mm:ss'),
        productStatus: this.info.productStatus
      };
      if (this.saveSubDisable) {
        return
      }
      if (!param.qty) {
        this.$toast.fail("请填写明细数量")
        return
      }
      this.saveSubDisable = true;
      if (this.saveDetailInfoType === 0) {
        this.handleCreateBand(param);
      } else {
        this.handleUpdateBand(param);
      }
    },
    // 更新明细
    handleUpdateBand(param) {
      this.$post(this.URL.updateBand, param).then(res => {
        if (res.success) {
          this.onSendClose();
          this.onSendSaveSuccess();
          this.$toast.success("数据更新成功");
        }
        this.saveSubDisable = false;
      }).finally(() => {
        this.saveSubDisable = false;
      });
    },
    // 新增收货明细
    handleCreateBand(param) {
      this.$post(this.URL.createBand, param).then(res => {
        if (res.success) {
          this.onSendClose();
          this.onSendSaveSuccess();
          this.$toast.success("录入成功");
        } else {
          this.$toast.fail(res.message);
        }
        this.saveSubDisable = false;
      }).finally(() => {
        this.saveSubDisable = false;
      });
    },
    // 保存成功发送事件
    onSendSaveSuccess() {
      this.$emit("detailEventSuccess");
    }
  }
};
</script>

<style lang="scss" scoped>
.van-overlay {
  padding: 3rem 1rem 1rem 1rem;
}

.form-content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0.3rem;
  color: #444;

  .tool {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 2.6rem;
    align-items: center;
    padding: 0 0.5rem;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;

    i {
      font-size: 0.9rem;
    }
  }
}

.form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0.5rem;

  section {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    font-size: 0.85rem;

    label:first-child {
      display: inline-flex;
      width: 5rem;
    }

    .van-cell {
      padding: 0;
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      line-height: 2rem;
    }

    .van-radio-group {
      display: flex;
      width: 100%;
      padding-left: 0.5rem;
    }

    .van-radio {
      width: 6rem;
    }

    .date {
      border: 1px solid #f0f0f0;
      border-radius: 0.2rem;
      width: 13rem;
      padding-left: 0.5rem;
      box-sizing: border-box;
      line-height: 2rem;
    }
  }

  .rejects-flag {
    display: flex;
    flex-wrap: wrap; /* 超出自动换行，默认nowrap不换行 */
    div {
      display: inline-flex;
      align-items: center;
      margin-left: 0.3rem;
      i {
        font-size: 1.2rem;
        margin-right: 0.3rem;
        color: #dc6350;
      }
    }
  }
}

.sub-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  align-content: center;
  justify-content: flex-end;
  padding-right: 1rem;
  border-top: 1px solid #eee;
  align-items: center;

  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 2rem;
    background-color: #dc6350;
    color: white;
    font-size: 0.9rem;
    border-radius: 0.3rem;
  }
}

.date-picker {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;

  .van-picker {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/receivingDetailEditDialog.vue